const ENDPOINT = window.alumitank?.formsEndpoint;

function fieldValue(form, role) {
	const els = form.querySelectorAll(`[data-webhook-field="${role}"]`);
	if (!els.length) return '';
	if (els[0].type === 'radio') {
		const checked = Array.from(els).find((el) => el.checked);
		return checked ? checked.value.trim() : '';
	}
	return (els[0].value || '').trim();
}

function fullName(form) {
	const full = fieldValue(form, 'name');
	if (full) return full;
	return `${fieldValue(form, 'first-name')} ${fieldValue(form, 'last-name')}`.trim();
}

function joinLines(pairs) {
	return pairs
		.filter(([, v]) => v && String(v).trim())
		.map(([k, v]) => `${k}: ${v}`)
		.join('\n');
}

const BUILDERS = {
	contact(form) {
		const tankTypes = fieldValue(form, 'tank-types');
		const comment = fieldValue(form, 'comment');
		const message = [
			tankTypes ? `Tank type(s): ${tankTypes}` : '',
			comment,
		].filter(Boolean).join('\n\n');
		return {
			form_type: 'contact',
			name: fullName(form),
			email: fieldValue(form, 'email'),
			phone: fieldValue(form, 'phone'),
			company: '',
			message,
		};
	},

	quote(form) {
		const meta = joinLines([
			['Quantity', fieldValue(form, 'quantity')],
			['Timeline', fieldValue(form, 'timeline')],
		]);
		const comment = fieldValue(form, 'comment');
		const message = [meta, comment].filter(Boolean).join('\n\n');
		return {
			form_type: 'quote',
			name: fullName(form),
			email: fieldValue(form, 'email'),
			phone: fieldValue(form, 'phone'),
			company: fieldValue(form, 'company'),
			message,
		};
	},

	dealer(form) {
		const billingAddress = [
			fieldValue(form, 'billing-address'),
			fieldValue(form, 'city'),
			fieldValue(form, 'state'),
			fieldValue(form, 'zip'),
			fieldValue(form, 'country'),
		].filter(Boolean).join(', ');
		const meta = joinLines([
			['Job title', fieldValue(form, 'job-title')],
			['Company phone', fieldValue(form, 'company-phone')],
			['Billing address', billingAddress],
			['Shipping address', fieldValue(form, 'shipping-address')],
			['Billing email', fieldValue(form, 'billing-email')],
			['Website', fieldValue(form, 'website')],
			['Number of stores', fieldValue(form, 'number-of-stores')],
			['Years in business', fieldValue(form, 'years-in-business')],
			['Sales channel', fieldValue(form, 'sales-channel')],
			['Heard about us', fieldValue(form, 'hear-about')],
		]);
		const comment = fieldValue(form, 'comment');
		const message = [meta, comment].filter(Boolean).join('\n\n');
		return {
			form_type: 'dealer',
			name: fullName(form),
			email: fieldValue(form, 'email'),
			phone: fieldValue(form, 'phone'),
			company: fieldValue(form, 'company'),
			message,
		};
	},

	industries(form) {
		return {
			form_type: 'industries',
			name: fullName(form),
			email: fieldValue(form, 'email'),
			phone: fieldValue(form, 'phone'),
			company: '',
			message: fieldValue(form, 'comment'),
		};
	},
};

export default (formType) => ({
	formType,

	handleSubmit($event) {
		if (!ENDPOINT) return;
		const build = BUILDERS[formType];
		if (!build) return;
		try {
			const payload = build($event.target);
			fetch(ENDPOINT, {
				method: 'POST',
				headers: { 'Content-Type': 'application/json' },
				body: JSON.stringify(payload),
				keepalive: true,
			}).catch((err) => console.error('[siteForm] webhook failed', formType, err));
		} catch (err) {
			console.error('[siteForm] payload build failed', formType, err);
		}
	},
});
